import { Paper, Box, IconButton } from "@mui/material"
import { Close } from "@mui/icons-material"
import { FileInput, Form, Title } from "react-admin"
import blobToBase64 from "../files/blobToBase64"
import { apiService } from "../apiService"
import { useState } from "react"
import { XmlInvoiceDto } from "../GeneratedClients/FreeBillApi"
import XmlViewer from "./XmlViewer"

const XmlInvoicePreview = () => {

  const [xmlInvoice, setXmlInvoice] = useState<XmlInvoiceDto | undefined>(undefined)
  const [file, setFile] = useState<File | undefined>(undefined)

  const handleChange = async(file: File) => {
    const fileContentAsBase64WithHeader = await blobToBase64(file)
    const substrings = fileContentAsBase64WithHeader?.toString().split(',')
    const mimeType = substrings ? substrings[0] : null
    const fileContentAsBase64 = substrings ? substrings[1] : null 
    var {data} = await apiService.XmlInvoicesApi.getXmlInvoice({getXmlInvoiceFromFileQuery: {mimeType: mimeType, fileContentAsBase64: fileContentAsBase64}})
    setXmlInvoice(data)
    setFile(file)
  }

  const handleClick = () => {
    setFile(undefined)
    setXmlInvoice(undefined)
  }

  return (
    <Paper sx={{mt:2, maxWidth: 1200}}>
      <Title title={"X-Rechnung"} />
      <Box px={5} py={2}>
        <Form>
          <FileInput 
            source="file" 
            label="Xml- oder ZUGFeRD-Rechnung"
            helperText="Dateitypen: PDF, XML. Maximalgröße: 10MB."
            accept={['application/pdf', 'text/xml']}
            maxSize={10000000}
            onChange={handleChange}
          />
        </Form>
      </Box>
      <Box p={5} >
        {
          file &&
          <Box width={"100%"} position={"relative"}>
            <IconButton sx={{position: "absolute", top:-6, right: 3}} onClick={handleClick} ><Close /></IconButton>
          </Box>
        }
        <XmlViewer xmlInvoice={xmlInvoice} file={file} />
      </Box>
    </Paper>
  )
}

export default XmlInvoicePreview